import styled from "styled-components";

export const MonitoringWrapper = styled.div`
  padding: 24px;
  width: 100%;
  height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .ant-tabs {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .ant-tabs-content-holder {
    flex: 1;
    overflow: hidden;
  }

  .ant-tabs-content {
    height: 100%;
  }

  .ant-tabs-tabpane-active {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
`;

export const StatsRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  flex-shrink: 0;
`;

export const StatCard = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  min-width: 180px;
  flex: 1;
`;

export const ToolbarRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  flex-shrink: 0;
  gap: 12px;
`;

export const TableContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  min-height: 0;
`;
